module.exports = __webpack_public_path__ + "img/jobs.f989ba05.svg";